import React, { useEffect, useRef, useState } from 'react';

import Header from "./Header";
import SideMenu from "./SideMenu";
import Footer from "./Footer";

import '../styles/globals.css';

const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [favorites, setFavorites] = useState({});
  const rootRef = useRef(null);
  const headerRef = useRef(null);

  useEffect(() => {
    const updateHeaderHeight = () => {
      if (!rootRef.current || !headerRef.current) {
        return;
      }

      const headerElement = headerRef.current.querySelector('header');
      if (!headerElement) {
        return;
      }

      const height = headerElement.getBoundingClientRect().height;
      rootRef.current.style.setProperty('--header-height', `${height}px`);
    };

    updateHeaderHeight();

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined' && headerRef.current) {
      const headerElement = headerRef.current.querySelector('header');
      if (headerElement) {
        resizeObserver = new ResizeObserver(updateHeaderHeight);
        resizeObserver.observe(headerElement);
      }
    }

    window.addEventListener('resize', updateHeaderHeight);

    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

  // Sample featured product data
  const featuredProducts = [
    {
      id: 1,
      name: 'Professional Power Drill',
      image: 'https://via.placeholder.com/300x300?text=Power+Drill',
      price: 149.99,
      originalPrice: 199.99,
      rating: 4.5,
      reviews: 128,
    },
    {
      id: 2,
      name: 'Heavy Duty Hammer',
      image: 'https://via.placeholder.com/300x300?text=Hammer',
      price: 34.99,
      originalPrice: 49.99,
      rating: 4.8,
      reviews: 95,
    },
    {
      id: 3,
      name: 'Cordless Saw',
      image: 'https://via.placeholder.com/300x300?text=Cordless+Saw',
      price: 189.99,
      originalPrice: 249.99,
      rating: 4.6,
      reviews: 156,
    },
    {
      id: 4,
      name: 'Impact Driver Kit',
      image: 'https://via.placeholder.com/300x300?text=Impact+Driver',
      price: 119.99,
      originalPrice: 159.99,
      rating: 4.7,
      reviews: 203,
    },
    {
      id: 5,
      name: 'Grinder Tool',
      image: 'https://via.placeholder.com/300x300?text=Grinder',
      price: 79.99,
      originalPrice: 99.99,
      rating: 4.4,
      reviews: 67,
    },
    {
      id: 6,
      name: 'Angle Drill',
      image: 'https://via.placeholder.com/300x300?text=Angle+Drill',
      price: 99.99,
      originalPrice: 129.99,
      rating: 4.6,
      reviews: 112,
    },
  ];

  // Sample category data
  const categories = [
    {
      id: 1,
      name: 'Power Tools',
      image: 'https://via.placeholder.com/400x400?text=Power+Tools',
      productCount: 245,
      link: '#',
    },
    {
      id: 2,
      name: 'Hand Tools',
      image: 'https://via.placeholder.com/400x400?text=Hand+Tools',
      productCount: 189,
      link: '#',
    },
    {
      id: 3,
      name: 'Safety Equipment',
      image: 'https://via.placeholder.com/400x400?text=Safety',
      productCount: 156,
      link: '#',
    },
    {
      id: 4,
      name: 'Accessories',
      image: 'https://via.placeholder.com/400x400?text=Accessories',
      productCount: 298,
      link: '#',
    },
  ];

  const handleAddToCart = (productId) => {
    // console.log('Added to cart:', productId);
  };

  const handleToggleFavorite = (productId, isFavorite) => {
    setFavorites(prev => ({
      ...prev,
      [productId]: isFavorite
    }));
  };

  return (
    <div ref={rootRef} className="w-full min-h-screen bg-mqgrey6 overflow-x-hidden">
      {/* Header */}
      <div ref={headerRef}>
        <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      </div>

      {/* Main page contents */}
      <main className="relative bg-white z-0" style={{ paddingTop: 'var(--header-height, 0px)' }}>
        {/* Side Menu */}
        <SideMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

        {children}

        {/* Footer */}
        <Footer />
      </main>
    </div>
  );
};

export default Layout;
